<div class="mobile-contact-wrapper">
  <div class="mobile-contact-trigger" (click)="toggleDropdown($event)">
    <span class="contact-label">{{ 'naglowek.kontakt.twoj-ksiegowy' | translate }}</span>
    <nb-icon icon="chevron-down-outline" [class.rotated]="isDropdownOpen"></nb-icon>
  </div>

  <div class="mobile-contact-dropdown" [class.open]="isDropdownOpen" [clamamss.align-right]="shouldAlignRight()" *ngIf="isDropdownOpen">
    <div class="dropdown-content">
      <!-- Accountant Name -->
      <div class="contact-info-item" *ngIf="kontakt?.opiekunGlownyImieNazwisko">
        <div class="contact-name">
          <nb-icon icon="person-outline"></nb-icon>
          <span [title]="kontakt.opiekunGlownyImieNazwisko">{{ kontakt.opiekunGlownyImieNazwisko }}</span>
        </div>
      </div>

      <!-- Phone Option -->
      <div class="contact-action-item" *ngIf="getMainPhone()" (click)="callPhone(getMainPhone(), $event)">
        <nb-icon icon="phone-outline"></nb-icon>
        <span [title]="getMainPhone()">{{ getMainPhone() }}</span>
      </div>

      <!-- Email Option -->
      <div class="contact-action-item" *ngIf="getMainEmail()" (click)="sendEmail(getMainEmail(), $event)">
        <nb-icon icon="email-outline"></nb-icon>
        <span [title]="getMainEmail()">{{ getMainEmail() }}</span>
      </div>

      <!-- Send Message Option -->
      <div class="contact-action-item message-action" (click)="openMessageDialog($event)">
        <nb-icon icon="message-square-outline"></nb-icon>
        <span [title]="'akcja.wyslij-wiadomosc' | translate">{{ 'akcja.wyslij-wiadomosc' | translate }}</span>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop to close dropdown when clicking outside -->
<div class="dropdown-backdrop" *ngIf="isDropdownOpen" (click)="closeDropdown()"></div>